import module from './module.js'
// Components
import './components/component.js'
import './components/avatar/component.js'
import './components/avatar/seleccionar/component.js'
import './components/clientes/component.js'
import './components/clientes/agregar/component.js'
import './components/clientes/lista/component.js'
import './components/clientes/lista/item/component.js'
import './components/clientes/eliminar/component.js'
import './components/clientes/eliminar/confirmar/component.js'
import './components/configuracion/component.js'
import './components/configuracion/facturacion/component.js'
import './components/configuracion/facturacion/confirmacion/component.js'
import './components/configuracion/facturacion/direcciones/component.js'
import './components/configuracion/facturacion/direcciones/item/component.js'
import './components/configuracion/facturacion/direcciones/editar/component.js'
import './components/configuracion/facturacion/direcciones/editar/confirmacion/component.js'
import './components/configuracion/documentos/component.js'
import './components/configuracion/documentos/confirmacion/component.js'
import './components/configuracion/documentos/eliminar/component.js'
import './components/configuracion/documentos/eliminar/confirmacion/component.js'
import './components/configuracion/registroPatronal/component.js'
import './components/configuracion/registroPatronal/agregar/component.js'
import './components/configuracion/registrosPatronales/component.js'
import './components/configuracion/registrosPatronales/agregar/component.js'
import './components/configuracion/registrosPatronales/migrar/component.js'
import './components/configuracion/registrosPatronales/migrar/agrupacion/component.js'
import './components/configuracion/registrosPatronales/migrar/confirmar/component.js'
import './components/configuracion/registrosPatronales/migrar/agrupacion/item/component.js'
import './components/cuenta/component.js'
import './components/cuenta/documentos/component.js'
import './components/cuenta/documentos/agregar/component.js'
import './components/cuenta/documentos/documento/component.js'
import './components/cuenta/documentos/eliminar/component.js'
import './components/cuenta/informacion/component.js'
import './components/cuentas/component.js'
import './components/cuentas/agregar/component.js'
import './components/cuentas/agregar/confirmacion/component.js'
import './components/cuentas/exportar/component.js'
import './components/informacion/component.js'
import './components/informacion/principal/component.js'
import './components/informacion/principal/confirmacion/component.js'
import './components/informacion/direcciones/component.js'
import './components/informacion/direcciones/agregar/component.js'
import './components/informacion/direcciones/agregar/confirmacion/component.js'
import './components/informacion/direcciones/editar/component.js'
import './components/informacion/direcciones/editar/confirmacion/component.js'
import './components/informacion/direcciones/eliminar/component.js'
import './components/informacion/direcciones/eliminar/confirmacion/component.js'
import './components/informacion/direcciones/lista/component.js'
import './components/informacion/direcciones/lista/item/component.js'
import './components/informacion/direcciones/matriz/component.js'
import './components/informacion/direcciones/matriz/confirmacion/component.js'
import './components/informacion/sat/component.js'
import './components/informacion/sat/agregar/component.js'
import './components/informacion/sat/agregar/confirmacion/component.js'
import './components/informacion/sat/confirmacion/component.js'
import './components/informacion/sat/confirmacionCertificados/component.js'
import './components/informacion/sat/eliminar/component.js'
import './components/informacion/sat/eliminar/confirmacion/component.js'
import './components/reportes/component.js'
import './components/reportes/pld/component.js'
import './components/reportes/pld/excel/component.js'
import './components/reportes/pld/excel/confirmacion/component.js'
import './components/reportes/pld/xml/component.js'
import './components/reportes/pld/xml/confirmacion/component.js'
import './components/reportes/isn/component.js'
import './components/reportes/isn/confirmacion/component.js'
// Routes
import './routes/empresa.js'
import './routes/empresa/clientes.js'
import './routes/empresa/clientes/agregar.js'
import './routes/empresa/configuracion.js'
import './routes/empresa/configuracion/facturacion.js'
import './routes/empresa/configuracion/documentos.js'
import './routes/empresa/configuracion/registroPatronal.js'
import './routes/empresa/configuracion/registrosPatronales.js'
import './routes/empresa/configuracion/registrosPatronales/migrar.js'
import './routes/empresa/cuentas.js'
import './routes/empresa/cuentas/agregar.js'
import './routes/empresa/informacion.js'
import './routes/empresa/informacion/principal.js'
import './routes/empresa/informacion/sat.js'
import './routes/empresa/informacion/sat/agregar.js'
import './routes/empresa/informacion/direcciones.js'
import './routes/empresa/informacion/direcciones/agregar.js'
import './routes/empresa/reportes.js'
import './routes/empresa/reportes/pld.js'
import './routes/empresa/reportes/isn.js'
// Services
import './services/Empresa.js'
import './services/Empresa/Avatar.js'
import './services/Empresa/Catalogo/Clientes.js'
import './services/Empresa/Catalogo/RegimenFiscal.js'
import './services/Empresa/Catalogo/ProveedorFacturacion.js'
import './services/Empresa/Configuracion/RegistroPatronal.js'
import './services/Empresa/Configuracion/RegistroPatronal/Historial.js'
import './services/Empresa/Configuracion/RegistrosPatronales.js'
import './services/Empresa/Configuracion/RegistrosPatronales/Clases.js'
import './services/Empresa/Configuracion/RegistrosPatronales/Migrar.js'
import './services/Empresa/Configuracion/RegistrosPatronales/Migrar/Colaboradores.js'
import './services/Empresa/Configuracion/Documentos.js'
import './services/Empresa/Configuracion/Facturacion.js'
import './services/Empresa/Configuracion/Direccion.js'
import './services/Empresa/Cuentas.js'
import './services/Empresa/Cuentas/Existe.js'
import './services/Empresa/Cuentas/ExportarCuentas.js'
import './services/Empresa/Cuenta.js'
import './services/Empresa/Cuenta/Documentos.js'
import './services/Empresa/Cuenta/Documento.js'
import './services/Empresa/Cuenta/Informacion.js'
import './services/Empresa/Clientes.js'
import './services/Empresa/Cliente.js'
import './services/Empresa/Informacion.js'
import './services/Empresa/Informacion/Principal.js'
import './services/Empresa/Informacion/Direcciones.js'
import './services/Empresa/Informacion/Direcciones/Direccion.js'
import './services/Empresa/Informacion/Direcciones/Matriz.js'
import './services/Empresa/Informacion/Sat.js'
import './services/Empresa/Informacion/Sat/Certificados.js'
import './services/Empresa/Informacion/Sat/Certificado.js'
import './services/Empresa/Reportes.js'
import './services/Empresa/Reporte/Pld.js'
import './services/Empresa/Reporte/Isn.js'

export default module.name



// WEBPACK FOOTER //
// ./src/empresa/index.js